
















import { Component, Vue, Watch, PropSync, Prop } from "vue-property-decorator"
import { mapGetters } from "vuex"
import HtmlDiff from "./htmlDiff"
@Component({
    components: {},
    computed: {
        ...mapGetters(["currentUser"])
    }
})
export default class CompareHtml extends Vue {
    @PropSync("visible", { type: Boolean, default: false })
    visible_: boolean
    @Prop({ type: String, default: "" }) history_context?: string
    @Prop({ type: String, default: "" }) current_context?: string
    policyCompareHtml = ""

    @Watch("visible")
    visibleChange(val: boolean) {
        if (val) {
            this.policyCompareHtml = HtmlDiff.compare(this.history_context, this.current_context)
        }
    }
    onClose() {
        this.visible_ = false
    }
}
